import PolicyDocumentView from "../../components/public/PolicyDocumentView";

export default function ShippingServicePolicy() {
  return <PolicyDocumentView slug="shipping-service-policy" fallbackTitle="Shipping Service Policy" />;
}
